import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { Modal, Button } from "react-bootstrap";

let resolvePromise;

export function showConfirmBox(message = "Are you sure?", title = "Confirm Action") {
  return new Promise((resolve) => {
    resolvePromise = resolve;
    // create a div for modal
    const div = document.createElement("div");
    document.body.appendChild(div);
    const root = createRoot(div);
    root.render(<ConfirmModal title={title} message={message} root={root} container={div} />);
  });
}

const ConfirmModal = ({ title, message, root, container }) => {
  const rootContainer = document.getElementById("root-container");
  const [show, setShow] = useState(true);

  const handleConfirm = () => {
    setShow(false);
    resolvePromise(true);
  };

  const handleCancel = () => {
    setShow(false);
    resolvePromise(false);
  };

  const handleExited = () => {
    // Use setTimeout to defer unmounting and avoid race condition
    setTimeout(() => {
      root.unmount();
      // Remove the div from DOM after unmounting using the passed container reference
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    }, 0);
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      onExited={handleExited}
      container={rootContainer}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
